import MasterTablePage from '../components/MasterTablePage';
import {
  listCustomersPage,
  createCustomer,
  updateCustomer,
  deleteCustomer,
  bulkUploadCustomers,
} from '../api/customers';

const columns = [
  { key: 'customerName', label: 'Name' },
  { key: 'channel', label: 'Channel' },
  { key: 'subChannel', label: 'Sub-Channel' },
  { key: 'salesmanCode', label: 'Salesman Code' },
];

// Channel is not edited here — it's derived automatically from the assigned Salesman's
// Channel (set in Salesman Master). Only Sub-Channel and the Salesman assignment are
// managed directly on the Customer.
const fields = [
  { name: 'customerName', label: 'Customer Name' },
  { name: 'subChannel', label: 'Sub-Channel', required: false },
  { name: 'salesmanCode', label: 'Salesman Code' },
];

export default function CustomerMaster() {
  return (
    <MasterTablePage
      title="Customer Master"
      columns={columns}
      fields={fields}
      api={{
        list: listCustomersPage,
        create: createCustomer,
        update: updateCustomer,
        remove: deleteCustomer,
        bulkUpload: bulkUploadCustomers,
      }}
      uploadTemplateHint="Columns: customerName, subChannel, salesmanCode — matched to existing customers by Name; creates a new customer if the name isn't found. Channel is not set here — it's derived automatically from the Salesman's Channel."
    />
  );
}
